import React, { useEffect, useState } from "react";
import ContentHeader from '../../components/ContentHeader';
import Loader from "../../components/Loader";
import Swal from "sweetalert2";
import axios from "axios";
import $ from 'jquery';
import "select2";
import "select2/dist/css/select2.min.css";
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import { Tooltip } from 'bootstrap';

// Obtener la fecha de hoy en formato yyyy-mm-dd
const today = new Date();
const yyyy = today.getFullYear();
const mm = String(today.getMonth() + 1).padStart(2, '0');
const dd = String(today.getDate()).padStart(2, '0');
const todayStr = `${yyyy}-${mm}-${dd}`;

const DriverReport = () => {
    const [loading, setLoading] = useState(false);
    const [reportData, setReportData] = useState([]);
    const [filterStartDate, setFilterStartDate] = useState(todayStr);
    const [filterEndDate, setFilterEndDate] = useState(todayStr);
    const [drivers, setDrivers] = useState([]);
    const [selectedDriver, setSelectedDriver] = useState('');
    const [salaryPerTrip, setSalaryPerTrip] = useState(0);
    const [summaryData, setSummaryData] = useState([]);
    const [currentUser, setCurrentUser] = useState(null);

    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

    useEffect(() => {
        initializeUser();
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.forEach((el) => new Tooltip(el));
    }, []);

    const initializeUser = () => {
        try {
            // OBTENER USER_ID COMO EN TICKETS - usando dataUser
            const userData = JSON.parse(localStorage.getItem("dataUser"));
            console.log('🔍 dataUser from localStorage:', userData);
            
            if (!userData || !userData.user_id) {
                throw new Error('No se encontró información de usuario en dataUser');
            }

            setCurrentUser(userData);
            console.log('✅ Current user set:', userData);

            // Si es admin (rol_id = 1), cargar conductores
            if (userData.rol_id === 1) {
                fetchDrivers();
                setSalaryPerTrip(0);
            } else {
                // Para no-admins, establecer sueldo por defecto en 250
                setSalaryPerTrip(250);
                // Cargar automáticamente el reporte del conductor
                handleAutoLoad();
            }

        } catch (error) {
            console.error('Error initializing user:', error);
            Swal.fire({
                icon: 'error',
                title: TITLEALERT,
                text: 'Error al cargar la información del usuario: ' + error.message
            });
        }
    };

    useEffect(() => {
        if (drivers.length > 0 && currentUser?.rol_id === 1) {
            const select = $("#driver_id");
            
            select.select2({
                width: "resolve",
                placeholder: "Seleccione un conductor"
            });
            
            // Handle change event
            select.on('change', (e) => {
                const value = $(e.target).val();
                console.log('Select2 change event - Value:', value);
                setSelectedDriver(value);
            });
            
            // Clean up on unmount
            return () => {
                select.off('change');
                select.select2('destroy');
            };
        }
    }, [drivers, currentUser]);

    // Calcular resumen cuando cambian los datos del reporte
    useEffect(() => {
        calculateSummary();
    }, [reportData, salaryPerTrip]);

    const fetchDrivers = async () => {
        try {
            const res = await axios.get(ENDPOINT + "get-all-drivers/2");
            setDrivers(res.data.data || []);
        } catch (error) {
            console.error("Error al cargar conductores:", error);
        }
    };

    // Carga automática para usuarios no-admin
    const handleAutoLoad = () => {
        if (!currentUser) return;
        
        const filters = {
            start_date: filterStartDate,
            end_date: filterEndDate
        };
        console.log('🔄 Auto-loading for non-admin user:', currentUser);
        getAll(filters);
    };

    const getAll = async (filters = {}) => {
        if (!currentUser) {
            console.error('No current user available');
            return;
        }

        setLoading(true);
        try {
            if ($.fn.DataTable.isDataTable('.main')) {
                $('.main').DataTable().destroy();
            }

            // Usamos el endpoint de viajes que ya devuelve el ingreso de camino
            // Preparamos FormData similar a Trips.getAll
            const form = new FormData();
            form.append('status_filter', 1); // solo viajes activos
            form.append('unit_filter', 0);
            if (filters.start_date && filters.end_date) {
                form.append('start_date', filters.start_date);
                form.append('end_date', filters.end_date);
            } else {
                form.append('start_date', filters.start_date || '');
                form.append('end_date', filters.end_date || '');
            }

            console.log('📤 Sending API request to get-trips-day with form data');
            const response = await axios.post(ENDPOINT + 'get-trips-day', form, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            console.log('📥 API Response:', response);
            const trips = response.data.data || [];

            // Filtrar por conductor si aplica (admin selecciona conductor o usuario normal)
            let filtered = trips;
            if (currentUser?.rol_id === 1) {
                if (filters.driver && filters.driver !== '' && filters.driver !== 'all') {
                    filtered = trips.filter(t => String(t.driver_id) === String(filters.driver));
                }
            } else {
                filtered = trips.filter(t => String(t.driver_id) === String(currentUser.driver_id));
            }

            // Asegurar que exista bill_way_ingreso en cada registro
            const normalized = filtered.map(t => ({
                ...t,
                bill_way_ingreso: t.bill_way_ingreso ? Number(t.bill_way_ingreso) : 0
            }));

            setReportData(normalized);

            setTimeout(() => {
                $('.main').DataTable({
                    pageLength: 50,
                    ordering: true,
                    language: {
                        search: "Buscar:",
                        lengthMenu: "Mostrar _MENU_ registros",
                        zeroRecords: "No se encontraron resultados",
                        info: "Mostrando _START_ a _END_ de _TOTAL_ registros",
                        infoEmpty: "Mostrando 0 a 0 de 0 registros",
                        paginate: {
                            first: "Primero",
                            last: "Último",
                            next: "Siguiente",
                            previous: "Anterior"
                        }
                    }
                });
            }, 100);
        } catch (error) {
            console.error('Error al cargar reporte:', error);
            Swal.fire({
                icon: 'error',
                title: TITLEALERT,
                text: 'Error al cargar el reporte.'
            });
        } finally {
            setLoading(false);
        }
    };

    const calculateSummary = () => {
        if (!reportData.length) {
            setSummaryData([]);
            return;
        }

        console.log('🧮 Calculating summary for:', reportData.length, 'trips');
        console.log('👤 User role:', currentUser?.rol_id);

        // PARA ADMINISTRADORES (rol_id = 1)
        if (currentUser?.rol_id === 1) {
            // Si admin selecciona un conductor específico
            if (selectedDriver && selectedDriver !== 'all') {
                const driverTrips = reportData.filter(trip => 
                    String(trip.driver_id) === String(selectedDriver)
                );

                const tripCount = driverTrips.length;
                const totalSalary = tripCount * salaryPerTrip;
                const totalIngreso = driverTrips.reduce((sum, t) => sum + (Number(t.bill_way_ingreso) || 0), 0);
                const driverName = driverTrips[0]?.driver?.name || drivers.find(d => String(d.driver_id) === String(selectedDriver))?.name || 'Conductor';

                setSummaryData([
                    {
                        driverId: selectedDriver,
                        driverName: driverName,
                        tripCount: tripCount,
                        totalSalary: totalSalary,
                        totalIngreso: totalIngreso
                    },
                    {
                        driverId: 'total',
                        driverName: 'TOTAL',
                        tripCount: tripCount,
                        totalSalary: totalSalary,
                        totalIngreso: totalIngreso
                    }
                ]);
            } 
            // Si admin ve TODOS los conductores
            else {
                const groupedByDriver = {};
                reportData.forEach(trip => {
                    const driverId = trip.driver_id || 'unknown';
                    if (!groupedByDriver[driverId]) {
                        groupedByDriver[driverId] = {
                                    driverId,
                                    driverName: trip.driver?.name || 'Sin conductor',
                                    tripCount: 0,
                                    totalSalary: 0,
                                    totalIngreso: 0
                                };
                    }
                    groupedByDriver[driverId].tripCount += 1;
                            groupedByDriver[driverId].totalSalary = groupedByDriver[driverId].tripCount * salaryPerTrip;
                            groupedByDriver[driverId].totalIngreso += Number(trip.bill_way_ingreso) || 0;
                });

                const summaryArray = Object.values(groupedByDriver);
                const totalTrips = summaryArray.reduce((sum, item) => sum + item.tripCount, 0);
                const totalSalary = summaryArray.reduce((sum, item) => sum + item.totalSalary, 0);
                const totalIngreso = summaryArray.reduce((sum, item) => sum + (item.totalIngreso || 0), 0);
                
                summaryArray.push({
                    driverId: 'total',
                    driverName: 'TOTAL',
                    tripCount: totalTrips,
                    totalSalary: totalSalary,
                    totalIngreso: totalIngreso
                });

                setSummaryData(summaryArray);
            }
        } 
        // PARA CONDUCTORES NORMALES (rol_id ≠ 1)
        else {
            const tripCount = reportData.length;
            const totalSalary = tripCount * salaryPerTrip;
            const driverName = reportData[0]?.driver?.name || 'Mi actividad';

            const totalIngreso = reportData.reduce((sum, t) => sum + (Number(t.bill_way_ingreso) || 0), 0);

            setSummaryData([
                {
                    driverId: currentUser?.driver_id,
                    driverName: driverName,
                    tripCount: tripCount,
                    totalSalary: totalSalary,
                    totalIngreso: totalIngreso
                },
                {
                    driverId: 'total',
                    driverName: 'TOTAL',
                    tripCount: tripCount,
                    totalSalary: totalSalary,
                    totalIngreso: totalIngreso
                }
            ]);
        }
    };

    const handleFilter = () => {
        const filters = {
            start_date: filterStartDate,
            end_date: filterEndDate
        };

        // Solo si es admin y selecciona un conductor específico
        if (currentUser?.rol_id === 1 && selectedDriver && selectedDriver !== 'all') {
            filters.driver = selectedDriver;
        }

        console.log('🎛️ Filters being sent:', filters);
        getAll(filters);
    };

    const handleReset = () => {
        setFilterStartDate(todayStr);
        setFilterEndDate(todayStr);
        setSelectedDriver('');
        
        if (currentUser?.rol_id === 1) {
            setSalaryPerTrip(0);
            // Reset Select2 value
            $('#driver_id').val('').trigger('change');
        } else {
            setSalaryPerTrip(250);
        }
        
        setReportData([]);
        setSummaryData([]);
        
        // Si no es admin, recargar automáticamente después del reset
        if (currentUser?.rol_id !== 1) {
            setTimeout(() => {
                handleAutoLoad();
            }, 100);
        }
    };

    // Determinar el título basado en el rol
    const getTitle = () => {
        if (currentUser?.rol_id === 1) {
            return "Reporte de Conductores";
        } else {
            return "Mi Reporte de Viajes";
        }
    };

    const isAdmin = currentUser?.rol_id === 1;

    // Si no hay usuario, mostrar loading
    if (!currentUser) {
        return <Loader />;
    }

    return (
        <div className="content-wrapper">
            <ContentHeader title={getTitle()} />

            <section className="content">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">{getTitle()}</h3>
                            <div className="row mt-2">
                                {/* Fechas */}
                                <div className="col-md-4">
                                    <label>Fecha Inicio</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={filterStartDate}
                                        onChange={(e) => setFilterStartDate(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label>Fecha Fin</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={filterEndDate}
                                        onChange={(e) => setFilterEndDate(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label>Sueldo por Corrida</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={salaryPerTrip}
                                        onChange={(e) => setSalaryPerTrip(Number(e.target.value))}
                                        placeholder="Ingrese el monto"
                                        min="0"
                                        step="0.01"
                                        disabled={!isAdmin}
                                    />
                                    {!isAdmin && (
                                        <small className="text-muted">Sueldo fijo: $250 por corrida</small>
                                    )}
                                </div>
                            </div>

                            <div className="row mt-3">
                                {/* Select de conductor solo para admin */}
                                {isAdmin && (
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="driver_id" className="form-label">
                                            Conductor
                                        </label>
                                        <div className="input-group">
                                            <span className="input-group-text">
                                                <i className="fas fa-user"></i>
                                            </span>
                                            <select
                                                id="driver_id"
                                                className="form-select select2"
                                                value={selectedDriver}
                                                onChange={(e) => {
                                                    console.log('Native select change:', e.target.value);
                                                    setSelectedDriver(e.target.value);
                                                }}
                                            >
                                                <option value="">Todos los conductores</option>
                                                <option value="all">--- TODOS LOS CONDUCTORES ---</option>
                                                {drivers.map((driver) => (
                                                    <option key={driver.driver_id} value={driver.driver_id}>
                                                        {driver.name} {driver.last_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <small className="text-muted mt-1 d-block">Filtrar por conductor específico</small>
                                    </div>
                                )}

                                <div className={isAdmin ? "col-md-6 mb-3 d-flex align-items-end" : "col-md-12 mb-3 d-flex align-items-end"}>
                                    <div className="d-flex w-100 gap-2">
                                        <button className="btn btn-primary w-50" onClick={handleFilter}>
                                            <i className="fas fa-filter me-1"></i> {isAdmin ? 'Filtrar' : 'Actualizar'}
                                        </button>
                                        <button className="btn btn-secondary w-50" onClick={handleReset}>
                                            <i className="fas fa-times me-1"></i> Limpiar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Tabla de Resumen */}
                        {summaryData.length > 0 && (
                            <div className="card-body border-bottom">
                                <h5 className="mb-3">Resumen de Viajes y Sueldo</h5>
                                <table className="table table-bordered table-sm">
                                    <thead className="table-primary">
                                        <tr>
                                            <th>Conductor</th>
                                            <th>N° de Corridas</th>
                                            <th>Sueldo Total</th>
                                            <th>Ingreso Camino</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {summaryData.map((item, index) => (
                                            <tr key={index} className={item.driverId === 'total' ? 'table-active fw-bold' : ''}>
                                                <td>{item.driverName}</td>
                                                <td>{item.tripCount}</td>
                                                <td>${(item.totalSalary || 0).toFixed(2)}</td>
                                                <td>${(item.totalIngreso || 0).toFixed(2)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        <div className="card-body">
                            <table className="table table-bordered table-striped main">
                                <thead>
                                    <tr>
                                        <th>Horario</th>
                                        <th>Fecha de Viaje</th>
                                        <th>Conductor</th>
                                        <th>Letra</th>
                                        <th>Sucursal</th>
                                        <th>Ingreso Camino</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reportData.map((row, index) => {
                                        const time = row.time || row.schedule?.time || row.fecha_horario || '—';
                                        const date = row.date || row.fecha_horario || '—';
                                        const driverName = row.driver?.name || (row.driver_name ? row.driver_name : '—');
                                        const letra = row.nombre_letra || row.letter?.name || row.letter_name || '—';
                                        const sucursal = row.nombre_sucursal || row.schedule?.branch?.name || row.branch?.name || row.branch_name || '—';
                                        const ingreso = Number(row.bill_way_ingreso) || 0;
                                        return (
                                            <tr key={index}>
                                                <td>{time}</td>
                                                <td>{date}</td>
                                                <td>{driverName}</td>
                                                <td>{letra}</td>
                                                <td>{sucursal}</td>
                                                <td>${ingreso.toFixed(2)}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>

            {loading && <Loader />}
        </div>
    );
};

export default DriverReport;